import pick from 'lodash/pick';

import { types as sdkTypes } from '../../util/sdkLoader';
import { storableError } from '../../util/errors';
import {
  addMarketplaceEntities,
  getListingsById,
  getMarketplaceEntities,
} from '../../ducks/marketplaceData.duck';

import { fetchCurrentUser } from '../../ducks/user.duck';
import { dbInvoiceData } from '../ManageListingsPage/ManageListingsPage.duck';

const { UUID } = sdkTypes;

// ================ Action types ================ //

export const SHOW_LISTING_REQUEST = 'app/ListingPublishedPage/SHOW_LISTING_REQUEST';

export const SHOW_LISTING_SUCCESS = 'app/ListingPublishedPage/SHOW_LISTING_SUCCESS';

export const SHOW_LISTING_ERROR = 'app/ListingPublishedPage/SHOW_LISTING_ERROR';

export const UPDATE_CURRENT_LISTING_LOCALLY =
  'app/ListingPublishedPage/UPDATE_CURRENT_LISTING_LOCALLY';

// ================ Reducer ================ //

const initialState = {
  showListingError: null,

  currentListing: null,
  id: null,
};

const ListingPublishedPageReducer = (state = initialState, action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case SHOW_LISTING_REQUEST:
      return { ...state, id: payload.id, showListingError: null };

    case SHOW_LISTING_SUCCESS:
      return { ...state, currentListing: { ...payload.data }, showListingError: null };

    case SHOW_LISTING_ERROR:
      return { ...state, showListingError: payload };

    case UPDATE_CURRENT_LISTING_LOCALLY:
      return { ...state, currentListing: payload };

    default:
      return state;
  }
};

export default ListingPublishedPageReducer;

// ================ Action creators ================ //

export const showListingRequest = id => ({
  type: SHOW_LISTING_REQUEST,
  payload: { id },
});
export const showListingSuccess = data => ({
  type: SHOW_LISTING_SUCCESS,
  payload: { data },
});

export const showListingError = e => ({
  type: SHOW_LISTING_ERROR,
  error: true,
  payload: e,
});

export const currentListingLocalUpdate = data => ({
  type: UPDATE_CURRENT_LISTING_LOCALLY,
  payload: data,
});

// ================ Thunks ================ //

export const showListing = listingId => (dispatch, getState, sdk) => {
  // console.log(1);
  dispatch(showListingRequest(listingId));
  dispatch(fetchCurrentUser());
  // console.log(3);

  const params = {
    id: listingId,
  };
  //   console.log(params, 2);
  const show = sdk.ownListings.show(params);
  // console.log(4, params);
  return show
    .then(data => {
      // console.log(8888, data);
      dispatch(addMarketplaceEntities(data));
      dispatch(showListingSuccess(data?.data?.data));
    })
    .then(() => {
      dispatch(dbInvoiceData(listingId.uuid));
    })
    .catch(e => {
      dispatch(showListingError(storableError(e)));
    });
};

export const updateCurrentListingLocally = listingId => (dispatch, getState, sdk) => {
  const state = getState();
  const ref = { id: listingId, type: 'ownListing' };
  const listingDetails = getMarketplaceEntities(state, [ref]);
  dispatch(currentListingLocalUpdate(listingDetails[0]));
};

// Helper function for loadData call.

export const loadData = (params, search) => dispatch => {
  // console.log(85, params);
  const listingId = new UUID(params.id);

  return dispatch(showListing(listingId));
};
